function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "5ssfa"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M50 90c-22.12 0-40-17.88-40-40s17.88-40 40-40 40 17.88 40 40-17.88 40-40 40z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "5ssfb"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M50 100C22.35 100 0 77.65 0 50S22.35 0 50 0s50 22.35 50 50-22.35 50-50 50z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#eee",
  strokeMiterlimit: 20,
  strokeWidth: 2,
  d: "M50 90c-22.12 0-40-17.88-40-40s17.88-40 40-40 40 17.88 40 40-17.88 40-40 40z",
  clipPath: "url(\"#5ssfa\")"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#eee",
  strokeMiterlimit: 20,
  strokeWidth: 2,
  d: "M50 100C22.35 100 0 77.65 0 50S22.35 0 50 0s50 22.35 50 50-22.35 50-50 50z",
  clipPath: "url(\"#5ssfb\")"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M63.5 40.82c0-8.436-6.716-15.274-15-15.274-8.284 0-15 6.838-15 15.274C33.5 58.64 26 63.73 26 63.73h45s-7.5-5.091-7.5-22.911z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#424143",
  strokeLinecap: "round",
  strokeMiterlimit: 20,
  strokeWidth: 5,
  d: "M63.5 40.82c0-8.436-6.716-15.274-15-15.274-8.284 0-15 6.838-15 15.274C33.5 58.64 26 63.73 26 63.73v0h45v0s-7.5-5.091-7.5-22.911z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M52.825 73.914a4.984 4.984 0 0 1-4.325 2.537 4.984 4.984 0 0 1-4.325-2.537"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#424143",
  strokeLinecap: "round",
  strokeMiterlimit: 20,
  strokeWidth: 5,
  d: "M52.825 73.914a4.984 4.984 0 0 1-4.325 2.537 4.984 4.984 0 0 1-4.325-2.537"
}))))));

var SvgIconNotifications = function SvgIconNotifications(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNotifications, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-notifications.71f346ff.svg";
export { ForwardRef as ReactComponent };